import React from "react";

const NidoranF = ({ ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-0.05 0.15 164.5 162.0"
      {...rest}
    >
      <g>
        <path
          fill="#ffffff"
          d="M47.45 119.65 L54.9 114.7 58.0 117.8 Q61.2 121.05 61.65 121.9 62.35 123.25 55.4 123.55 L51.45 121.7 47.45 119.65"
        />
        <path
          fill="#dbdcdc"
          d="M54.9 114.7 L57.75 117.5 Q52.55 118.5 49.0 120.4 L47.45 119.65 54.9 114.7"
        />
        <path
          fill="#d2ddf0"
          d="M62.6 35.8 Q67.1 49.5 46.1 68.25 35.55 77.65 24.15 84.3 17.25 75.85 12.9 64.55 5.35 45.05 9.65 25.35 10.55 24.8 11.9 24.55 13.7 24.25 13.8 25.35 14.1 29.6 16.5 38.85 17.05 33.05 18.95 25.6 22.75 10.6 29.5 2.15 30.5 0.9 32.85 0.8 35.15 0.65 35.1 1.6 35.1 2.7 34.15 7.0 33.15 11.55 33.0 13.5 43.2 11.5 49.65 15.55 57.55 20.5 62.6 35.8"
        />
        <path
          fill="#b5bfd0"
          d="M49.25 15.3 Q57.4 20.15 62.6 35.8 66.25 46.9 52.85 61.6 44.2 71.1 29.9 80.65 24.8 73.6 22.7 63.95 20.7 54.7 22.0 45.35 23.3 35.8 27.65 28.75 32.4 21.15 39.7 18.05 40.65 17.5 49.25 15.3"
        />
        <path
          fill="#d2ddf0"
          d="M24.55 93.55 L25.75 97.75 Q21.35 92.65 11.3 84.0 1.9 75.85 0.95 74.55 6.15 76.55 24.55 93.55"
        />
        <path
          fill="#d2ddf0"
          d="M33.6 108.1 L34.2 109.95 19.4 109.25 3.7 109.0 Q8.65 107.85 20.15 107.75 28.85 107.7 33.6 108.1"
        />
        <path
          fill="#d2ddf0"
          d="M123.5 66.7 L132.8 58.25 Q136.05 55.1 136.7 54.7 137.9 54.0 139.6 55.1 141.4 56.25 141.6 58.05 141.9 60.5 141.3 79.4 134.7 78.1 129.15 75.9 118.1 71.4 123.5 66.7"
        />
        <path
          fill="#b5bfd0"
          d="M141.6 58.05 Q141.9 60.5 141.3 79.4 135.0 78.2 129.6 76.05 118.7 71.8 122.95 67.3 127.2 69.25 133.35 63.35 137.7 59.15 139.1 56.2 139.5 55.4 140.55 56.4 141.5 57.3 141.6 58.05"
        />
        <path
          fill="#d2ddf0"
          d="M146.8 84.3 L150.8 82.1 Q154.25 80.2 154.7 79.75 155.4 79.05 156.4 80.8 157.45 82.6 157.0 84.25 L155.0 94.35 146.8 84.3"
        />
        <path
          fill="#b5bfd0"
          d="M147.4 83.95 Q149.95 85.7 152.85 84.15 154.45 83.3 155.9 81.6 156.5 80.95 156.9 82.2 157.25 83.35 157.0 84.25 L155.0 94.35 146.8 84.3 147.4 83.95"
        />
        <path
          fill="#b5bfd0"
          d="M157.15 123.95 Q161.4 127.0 162.05 132.65 162.65 138.0 159.9 142.25 157.55 145.95 153.6 149.2 149.95 152.15 147.7 152.65 142.6 153.75 138.4 153.45 132.3 153.05 129.7 149.6 135.1 142.15 141.2 135.2 153.45 121.3 157.15 123.95"
        />
        <path
          fill="#eeeeef"
          d="M131.1 148.5 L132.45 149.6 Q133.65 151.0 133.05 152.35 132.15 153.2 128.1 154.7 123.9 156.2 123.5 155.55 123.15 155.0 124.15 152.1 L125.2 149.3 131.1 148.5"
        />
        <path
          fill="#c8c9ca"
          d="M131.1 148.5 L132.45 149.6 Q133.65 151.0 133.05 152.35 132.5 152.9 130.05 153.9 127.65 154.95 125.7 155.45 126.2 153.15 124.5 151.05 L125.2 149.3 131.1 148.5"
        />
        <path
          fill="#c8c9ca"
          d="M145.95 148.7 Q149.05 150.0 149.5 151.4 149.95 152.7 145.75 155.3 141.65 157.85 139.9 157.65 139.1 157.55 140.0 153.55 140.85 149.55 141.9 148.35 142.75 147.35 145.95 148.7"
        />
        <path
          fill="#d2ddf0"
          d="M62.85 111.05 Q61.15 100.55 73.9 119.75 80.3 129.35 87.0 141.05 84.5 147.05 82.05 149.3 80.3 150.85 77.55 151.1 L71.35 151.35 Q67.4 151.2 66.75 150.2 63.3 144.7 63.45 132.6 63.65 116.05 62.85 111.05"
        />
        <path
          fill="#b5bfd0"
          d="M63.05 111.9 Q61.95 101.3 74.35 120.1 80.6 129.5 87.0 141.05 84.9 146.0 82.95 148.35 75.8 136.6 73.8 134.25 67.4 126.75 63.3 132.5 L63.5 123.65 Q63.65 117.7 63.05 111.9"
        />
        <path
          fill="#eeeeef"
          d="M80.4 148.55 Q83.4 146.2 83.95 147.15 84.5 148.1 84.9 149.85 85.4 151.8 84.8 152.05 L77.55 151.1 80.4 148.55"
        />
        <path
          fill="#c8c9ca"
          d="M82.3 147.25 L83.95 147.15 84.75 149.25 Q85.25 150.85 85.1 151.55 84.0 148.65 82.3 147.25"
        />
        <path
          fill="#eeeeef"
          d="M64.5 145.05 Q66.1 144.35 70.0 147.15 73.9 149.95 73.25 151.4 73.0 152.1 67.4 152.25 L60.65 151.7 Q59.85 151.3 61.25 148.6 62.7 145.8 64.5 145.05"
        />
        <path
          fill="#c8c9ca"
          d="M73.25 151.4 Q73.05 151.85 70.0 152.1 L64.25 152.2 68.35 150.65 Q70.7 149.55 71.3 148.2 73.75 150.35 73.25 151.4"
        />
        <path
          fill="#d2ddf0"
          d="M81.85 40.05 Q89.55 43.7 96.65 48.55 116.1 61.85 115.95 73.75 119.7 71.4 121.5 68.85 133.75 74.45 139.85 78.55 153.7 87.95 156.85 99.25 160.55 112.55 157.9 122.75 155.25 132.95 145.85 141.65 139.05 147.95 125.9 149.25 114.8 150.35 102.55 147.75 92.95 145.7 81.75 136.65 72.05 128.8 70.8 124.9 L67.85 117.5 Q65.65 112.45 65.3 110.55 L65.5 109.95 Q63.4 111.5 60.1 112.65 L55.55 114.2 Q53.65 115.0 51.25 117.0 48.95 118.95 47.65 119.4 45.3 120.15 41.3 118.75 36.9 117.15 35.4 114.2 L33.75 107.9 Q32.75 104.15 29.1 101.4 25.15 98.4 24.45 93.5 L24.15 81.25 Q23.9 73.4 29.05 62.15 34.2 50.7 40.95 44.5 51.2 34.9 72.2 36.6 75.0 36.85 81.85 40.05"
        />
        <path
          fill="#b5bfd0"
          d="M70.1 102.35 Q70.65 101.05 71.4 102.65 L72.45 106.3 Q73.25 110.1 71.6 115.15 69.95 120.25 70.8 124.9 L67.85 117.4 Q65.5 111.95 65.0 110.0 67.1 108.8 68.5 106.25 L70.1 102.35"
        />
        <path
          fill="#b5bfd0"
          d="M82.15 40.2 Q89.75 43.8 96.7 48.6 115.85 61.75 115.7 73.65 119.45 71.3 121.5 68.85 133.75 74.45 139.85 78.55 153.7 87.95 156.85 99.25 160.55 112.55 157.9 122.75 155.25 132.95 145.85 141.65 139.05 147.95 125.9 149.3 114.7 150.4 102.55 147.75 95.8 146.3 90.55 143.0 L85.65 139.55 Q92.25 142.65 103.2 140.95 116.25 138.95 119.4 129.95 124.7 114.65 116.05 100.6 106.5 85.15 85.0 82.0 82.7 64.5 74.85 54.0 66.2 42.5 50.2 38.45 54.9 36.7 61.15 36.45 L72.6 36.8 Q75.4 37.05 82.15 40.2"
        />
        <path
          fill="#d2ddf0"
          d="M25.4 48.45 Q27.4 43.55 29.0 44.95 30.05 45.85 35.15 48.65 L43.35 53.5 Q46.55 55.7 40.85 63.75 38.65 66.9 36.6 68.4 L33.9 68.45 Q32.35 63.6 24.95 55.2 23.35 53.4 25.4 48.45"
        />
        <path
          fill="#b5bfd0"
          d="M30.55 46.9 Q30.9 45.75 36.75 48.9 42.15 51.75 43.85 53.3 44.95 54.3 42.4 61.2 39.85 68.1 38.75 66.2 L33.0 59.4 Q28.5 54.35 28.9 53.5 29.35 52.6 29.85 50.3 L30.55 46.9"
        />
        <path
          fill="#ffffff"
          d="M55.5 82.8 Q57.65 79.9 59.85 78.7 62.7 79.75 64.8 83.05 66.4 85.6 67.2 88.8 67.2 90.7 65.4 92.6 63.95 94.1 60.9 96.1 58.7 97.55 55.45 98.3 L52.65 98.75 Q52.4 97.5 52.3 95.5 52.15 91.5 53.0 87.7 53.5 85.5 55.5 82.8"
        />
        <path
          fill="#dbdcdc"
          d="M62.5 80.35 Q59.1 83.0 56.15 87.8 52.45 93.75 52.65 98.55 52.35 97.1 52.3 94.8 52.25 91.15 53.0 87.7 53.5 85.5 55.5 82.8 57.65 79.9 59.85 78.7 61.35 79.25 62.5 80.35"
        />
        <path
          fill="#ca0336"
          d="M52.85 98.8 Q52.3 98.6 52.25 95.5 52.15 92.35 52.65 90.1 L53.5 86.15 Q54.1 84.2 55.35 83.05 58.4 83.95 59.95 88.65 61.45 93.15 60.1 96.35 59.4 97.05 56.4 98.05 53.45 99.0 52.85 98.8"
        />
        <path
          fill="#aa002b"
          d="M58.55 85.7 Q55.9 87.4 54.4 91.35 53.15 94.7 52.95 98.85 L52.85 98.8 Q52.3 98.6 52.2 95.35 52.1 92.15 52.55 89.85 L53.45 86.0 Q54.05 84.25 55.35 83.05 57.15 83.55 58.55 85.7"
        />
        <path
          fill="#ffffff"
          d="M55.75 92.25 L56.2 93.95 Q56.15 94.7 55.7 94.95 55.25 95.2 54.6 94.75 L53.5 93.4 Q53.05 92.5 53.05 91.7 53.05 90.9 53.55 90.7 54.0 90.45 54.65 90.9 55.3 91.35 55.75 92.25"
        />
        <path
          fill="#d2ddf0"
          d="M129.55 46.9 Q126.1 65.3 120.45 70.15 112.95 76.6 103.65 79.25 97.05 81.15 85.95 81.75 81.25 80.5 76.55 77.85 67.15 72.65 67.25 65.95 67.4 56.55 67.7 52.8 68.15 47.35 69.5 44.05 71.5 39.1 76.4 30.65 82.35 20.4 86.25 16.7 90.0 13.1 94.65 10.5 98.25 8.5 99.15 8.5 99.7 8.5 100.7 10.0 101.75 11.55 101.1 12.4 L95.75 19.3 Q90.95 25.7 90.15 27.9 95.0 23.3 103.4 18.8 112.3 14.05 116.9 14.05 120.95 14.05 132.3 17.55 140.3 20.0 143.6 21.3 144.75 21.75 145.15 23.9 145.6 26.15 143.7 26.3 L138.05 27.05 132.7 27.9 Q131.3 37.6 129.55 46.9"
        />
        <path
          fill="#915e82"
          d="M119.65 36.6 Q121.65 47.1 119.8 53.05 117.85 59.4 114.75 64.0 112.25 67.6 109.8 69.2 105.75 71.85 94.8 74.5 L84.65 76.6 Q84.5 74.8 83.4 72.75 81.3 68.7 76.9 67.55 76.2 64.1 78.7 54.65 81.05 45.55 83.35 41.45 85.3 38.0 93.6 32.65 100.85 27.9 104.0 26.95 106.5 26.2 111.45 25.95 116.5 25.7 116.95 26.4 118.15 28.5 119.65 36.6"
        />
        <path
          fill="#65a9dc"
          d="M105.65 41.75 Q108.25 45.7 108.05 54.6 107.85 62.55 106.25 65.3 L103.2 70.15 100.8 72.4 Q98.7 74.2 84.45 76.7 84.5 74.9 83.55 72.8 81.65 68.7 76.75 67.4 76.2 62.35 78.95 53.15 L81.75 45.0 Q85.6 42.45 93.35 40.45 103.15 38.0 105.65 41.75"
        />
        <path
          fill="#d2ddf0"
          d="M123.5 122.85 Q128.55 127.55 126.6 133.35 122.7 144.95 119.9 150.65 116.85 157.05 114.5 157.6 111.4 158.4 105.85 157.75 100.3 157.15 99.8 155.95 99.3 154.55 97.6 145.55 95.65 135.45 94.0 124.65 93.15 119.15 98.9 117.1 104.05 115.3 111.5 116.95 119.1 118.7 123.5 122.85"
        />
        <path
          fill="#b5bfd0"
          d="M127.95 122.0 Q129.35 125.85 126.6 133.35 121.85 146.2 119.05 151.8 116.35 157.15 114.5 157.6 111.15 158.4 105.65 157.75 111.05 154.9 115.7 145.6 121.35 134.3 121.2 120.85 126.5 117.95 127.95 122.0"
        />
        <path
          fill="#eeeeef"
          d="M99.55 153.75 Q100.55 153.3 102.5 155.0 104.2 156.45 104.8 157.7 105.25 158.6 102.0 158.85 L97.3 158.5 Q96.4 158.2 97.5 156.15 98.55 154.15 99.55 153.75"
        />
        <path
          fill="#c8c9ca"
          d="M104.8 157.7 Q105.25 158.6 102.0 158.85 L97.3 158.5 97.1 158.4 Q100.55 158.0 103.1 155.55 104.45 156.9 104.8 157.7"
        />
        <path
          fill="#eeeeef"
          d="M105.3 158.0 Q104.8 156.75 108.0 154.9 111.15 153.1 112.9 153.35 114.5 153.55 115.85 155.0 117.1 156.3 117.25 157.5 117.4 158.55 116.8 159.85 116.05 161.45 114.8 161.2 L109.55 160.1 Q105.7 159.05 105.3 158.0"
        />
        <path
          fill="#c8c9ca"
          d="M117.25 157.5 Q117.4 158.55 116.8 159.85 116.05 161.45 114.8 161.2 L111.25 160.5 Q116.05 158.4 114.55 153.95 L116.4 155.65 Q117.15 156.7 117.25 157.5"
        />
        <path
          fill="#7f5072"
          d="M126.7 78.45 Q129.0 79.35 131.75 83.4 132.7 84.8 130.65 86.3 128.65 87.75 126.9 87.25 125.6 86.85 124.65 84.5 123.85 82.4 123.9 80.65 123.9 79.35 124.6 78.7 125.35 77.95 126.7 78.45"
        />
        <path
          fill="#7f5072"
          d="M144.35 102.4 Q146.7 101.95 148.2 106.35 149.25 109.3 149.8 114.0 150.2 117.25 147.35 120.05 144.95 122.4 143.05 122.4 141.75 122.4 140.0 120.45 138.45 118.75 138.2 117.55 137.85 116.1 140.0 109.7 142.3 102.8 144.35 102.4"
        />
        <path
          fill="#915e82"
          d="M123.7 113.7 Q124.55 115.4 123.8 117.5 123.1 119.35 121.75 120.15 120.55 120.9 117.3 117.55 114.0 114.25 114.0 112.1 114.0 110.8 115.4 109.35 116.55 108.2 117.9 107.55 119.05 107.0 120.95 109.4 122.4 111.2 123.7 113.7"
        />
        <path
          fill="#7f5072"
          d="M123.7 113.7 Q124.55 115.4 123.8 117.5 123.1 119.35 121.75 120.15 L121.2 120.2 Q121.35 114.1 119.5 107.95 121.5 109.45 123.7 113.7"
        />
        <path
          fill="#915e82"
          d="M108.85 136.9 Q109.4 135.8 111.1 134.65 111.9 134.15 113.05 135.65 114.25 137.15 114.0 138.55 113.75 140.25 112.8 141.45 111.7 142.8 110.8 141.75 109.8 140.6 109.2 139.1 108.55 137.5 108.85 136.9"
        />
        <path
          fill="#915e82"
          d="M142.95 135.25 L142.05 136.95 140.05 138.85 Q139.05 139.55 138.55 138.1 138.15 136.8 138.35 135.25 138.55 134.0 139.9 133.1 141.15 132.2 141.75 132.7 L142.65 133.9 Q143.0 134.7 142.95 135.25"
        />
        <path
          fill="#d2ddf0"
          d="M85.95 92.35 Q69.7 99.3 67.0 100.65 64.55 101.9 64.5 100.35 64.4 98.75 66.75 97.9 L85.45 90.0 Q101.9 83.4 107.95 83.15 102.75 85.1 85.95 92.35"
        />
        <path
          fill="#d2ddf0"
          d="M57.75 108.8 L75.2 109.65 95.75 111.35 74.4 111.0 57.15 110.65 Q55.95 110.7 55.6 109.7 55.25 108.75 57.75 108.8"
        />
        <path
          fill="#0d131a"
          d="M62.1 121.65 Q62.35 122.2 62.0 122.6 61.35 123.5 58.5 123.95 L54.9 124.05 Q54.25 123.9 50.7 122.0 L46.9 120.0 48.05 119.3 51.5 121.15 55.2 123.0 58.45 122.8 Q61.0 122.45 61.2 122.05 61.35 121.7 58.9 119.2 L54.6 115.05 55.25 114.35 58.65 117.7 Q61.65 120.75 62.1 121.65"
        />
        <path
          fill="#0d131a"
          d="M52.3 16.2 Q59.75 21.9 63.4 36.05 L61.85 36.0 Q54.2 10.35 33.15 14.25 32.45 14.35 32.3 14.0 32.15 13.65 32.35 12.5 L34.15 1.95 32.35 1.85 Q30.45 2.15 30.1 2.6 24.1 9.85 20.3 23.35 17.7 32.6 17.25 38.9 17.05 41.75 16.35 40.8 15.9 40.15 15.4 38.25 L14.1 31.5 13.05 25.4 Q13.0 25.0 11.9 25.1 10.7 25.2 10.3 25.85 9.85 26.5 9.35 31.45 8.85 36.3 8.85 39.65 8.85 54.25 15.2 68.3 19.15 77.0 24.7 83.85 L24.3 84.95 Q15.85 77.55 10.55 61.85 4.1 42.75 8.95 25.2 9.2 24.35 11.65 23.75 L14.45 23.9 15.25 29.2 16.35 36.3 Q17.05 28.75 19.6 20.2 23.1 8.6 28.6 1.75 29.5 0.6 32.75 0.15 L36.0 0.3 Q36.1 1.05 35.1 6.3 L33.85 12.65 Q45.15 10.7 52.3 16.2"
        />
        <path
          fill="#0d131a"
          d="M0.05 73.85 Q0.15 73.6 1.1 74.15 6.9 77.55 14.2 83.7 L24.2 92.7 24.55 94.0 14.15 84.75 Q6.65 78.3 2.8 75.95 L9.35 81.75 17.6 89.0 Q22.2 93.2 25.25 96.7 L25.45 98.0 Q20.95 92.8 8.85 82.4 4.1 78.3 0.6 74.8 -0.05 74.05 0.05 73.85"
        />
        <path
          fill="#0d131a"
          d="M20.9 107.25 L33.65 107.7 33.55 108.5 23.6 108.2 8.95 108.65 34.25 109.5 34.15 110.35 18.1 109.65 3.7 109.4 2.2 109.15 Q2.3 108.9 3.6 108.6 9.75 107.3 20.9 107.25"
        />
        <path
          fill="#0d131a"
          d="M136.35 53.75 L139.45 53.9 Q140.6 54.45 141.55 55.8 142.5 57.15 142.65 58.3 142.9 60.1 141.85 79.7 L140.6 79.4 140.85 69.4 140.9 58.15 Q140.8 57.3 140.15 56.5 139.55 55.8 138.8 55.45 L137.05 55.3 130.1 61.65 Q123.4 67.9 122.7 68.4 L123.1 66.15 129.9 59.75 136.35 53.75"
        />
        <path
          fill="#0d131a"
          d="M155.85 79.0 Q156.8 79.35 157.45 81.3 158.15 83.3 157.75 84.8 157.15 87.1 155.5 95.45 L154.4 94.25 156.4 84.1 156.5 83.35 Q156.5 81.6 155.75 80.85 155.3 80.4 151.15 82.55 L147.1 84.8 146.15 83.7 150.5 81.2 Q155.0 78.7 155.85 79.0"
        />
        <path
          fill="#0d131a"
          d="M133.45 151.65 Q136.05 152.85 139.95 152.85 L139.95 154.15 Q135.1 154.15 132.35 152.9 133.4 152.15 133.45 151.65"
        />
        <path
          fill="#0d131a"
          d="M161.45 142.05 Q159.45 145.15 155.7 148.4 152.25 151.35 149.45 152.65 149.65 152.05 149.45 151.1 151.9 149.8 154.5 147.5 157.45 144.85 159.35 141.9 160.8 139.75 161.2 136.55 161.6 133.4 160.85 130.45 159.75 126.15 157.15 124.7 L157.45 123.05 Q159.15 123.95 160.6 126.0 162.05 128.1 162.65 130.45 164.45 137.5 161.45 142.05"
        />
        <path
          fill="#0d131a"
          d="M133.0 149.4 Q134.4 151.0 133.7 152.55 L131.1 154.15 Q127.7 155.9 123.55 156.6 122.5 156.75 122.5 155.65 122.5 154.15 123.3 152.25 L124.75 149.1 125.65 149.5 Q123.9 153.7 123.9 155.05 L123.9 155.25 Q124.7 155.45 128.25 154.1 131.7 152.8 132.65 152.05 L132.75 151.45 Q132.75 150.55 131.65 149.55 L130.55 148.65 131.35 148.05 133.0 149.4"
        />
        <path
          fill="#0d131a"
          d="M149.05 151.55 Q148.65 150.45 143.95 148.55 142.8 148.15 142.25 148.7 141.55 149.5 140.85 152.2 140.15 154.75 140.15 156.15 L140.4 156.8 141.4 156.9 Q147.0 154.4 148.7 152.3 L149.05 151.55 M141.15 148.4 L141.95 147.5 143.3 147.35 Q145.25 147.75 147.55 148.9 150.1 150.15 150.45 151.2 150.65 151.8 150.1 152.55 148.95 154.2 144.8 156.6 140.55 159.05 139.6 158.35 138.55 157.65 139.2 153.9 139.85 150.3 141.15 148.4"
        />
        <path
          fill="#0d131a"
          d="M63.3 111.3 Q64.55 113.2 64.5 122.15 L64.3 133.8 Q64.3 140.95 65.35 145.1 L64.0 145.2 Q62.75 140.55 62.6 134.6 62.5 131.0 62.95 122.75 63.15 119.45 62.7 116.05 62.25 112.95 61.7 112.15 L63.3 111.3"
        />
        <path
          fill="#0d131a"
          d="M73.3 150.8 L77.95 150.4 Q78.05 151.35 78.3 151.7 L77.6 151.75 72.95 152.0 73.3 150.8"
        />
        <path
          fill="#0d131a"
          d="M86.35 139.75 L87.9 140.8 Q86.3 144.65 84.35 147.6 84.0 147.35 83.2 147.05 84.2 145.5 86.35 139.75"
        />
        <path
          fill="#0d131a"
          d="M80.55 148.95 Q78.25 150.65 78.55 150.8 L81.1 151.25 83.9 151.55 Q84.7 151.5 83.95 149.0 L83.65 147.9 83.2 147.4 Q82.85 147.2 80.55 148.95 M80.65 152.35 L77.45 151.6 77.2 150.75 Q77.85 149.45 80.1 147.9 82.4 146.25 83.6 146.4 84.25 146.5 84.55 146.95 85.2 148.05 85.55 150.75 L85.6 152.4 Q85.35 152.95 84.0 152.9 L80.65 152.35"
        />
        <path
          fill="#0d131a"
          d="M64.8 145.8 Q63.85 146.0 62.4 148.45 61.0 150.9 61.35 151.3 L66.9 151.6 72.5 151.25 Q73.15 150.7 71.55 149.1 69.95 147.5 67.85 146.5 65.85 145.55 64.8 145.8 M64.3 144.6 Q65.55 144.05 68.2 145.4 70.65 146.6 72.35 148.3 74.3 150.2 73.7 151.6 73.6 151.95 73.0 152.15 L66.25 153.0 59.95 152.65 Q59.45 152.35 59.45 151.4 59.55 150.0 61.05 147.75 62.65 145.3 64.3 144.6"
        />
        <path
          fill="#0d131a"
          d="M71.8 123.8 Q73.3 127.4 80.4 133.9 88.8 141.6 97.05 144.95 L97.6 146.95 Q88.95 143.7 80.8 136.8 73.2 130.35 69.9 124.15 68.35 121.25 66.6 116.65 65.0 112.35 64.7 110.65 L66.05 110.75 Q66.35 112.35 68.85 117.65 L71.8 123.8"
        />
        <path
          fill="#0d131a"
          d="M140.65 79.95 Q133.85 75.1 122.55 70.05 L121.2 69.45 122.15 68.5 123.05 68.85 Q136.45 74.6 143.2 79.45 155.1 87.85 158.2 99.0 162.15 113.4 158.9 124.4 156.05 133.85 147.4 141.9 142.85 146.1 135.05 148.2 128.1 150.1 119.65 150.15 120.55 149.35 120.55 148.65 137.65 148.4 145.4 141.2 154.65 132.65 157.25 122.6 159.85 112.5 156.2 99.4 153.3 88.85 140.65 79.95"
        />
        <path
          fill="#0d131a"
          d="M70.3 103.3 Q69.5 106.7 66.95 109.25 L64.6 109.15 Q68.2 106.4 69.6 102.5 70.0 101.5 70.3 101.9 70.55 102.3 70.3 103.3"
        />
        <path
          fill="#0d131a"
          d="M24.15 96.75 Q23.05 93.7 23.05 86.9 L23.25 81.3 Q23.0 73.35 28.95 61.05 L29.6 61.95 30.35 62.85 Q24.65 74.95 24.85 81.25 L24.9 86.6 Q24.9 92.75 25.5 95.0 26.35 98.4 29.55 100.8 32.4 102.95 33.6 105.45 34.35 106.95 34.9 109.85 35.4 112.55 36.1 113.85 37.4 116.55 41.55 118.05 45.3 119.4 47.4 118.7 L50.7 116.55 Q53.15 114.4 55.3 113.5 L57.65 112.7 Q59.75 112.05 61.8 110.95 L63.75 110.9 65.5 110.9 61.7 112.95 58.1 114.1 55.85 114.9 Q54.15 115.55 51.65 117.65 49.3 119.6 47.85 120.1 45.25 120.95 41.05 119.6 36.35 118.1 34.75 114.9 34.2 113.8 33.45 110.1 L32.55 106.05 Q31.55 103.8 28.65 102.0 25.3 99.9 24.15 96.75"
        />
        <path
          fill="#0d131a"
          d="M72.5 37.55 Q62.1 35.8 52.15 39.15 41.85 42.65 37.75 49.95 L36.0 48.95 Q40.85 40.3 53.9 36.9 65.3 33.95 73.05 36.45 L72.5 37.55"
        />
        <path
          fill="#0d131a"
          d="M26.6 44.5 L30.45 44.6 Q31.45 45.35 36.75 48.5 42.35 51.8 43.45 52.2 44.65 52.65 44.45 53.4 44.3 54.1 43.4 53.6 31.0 47.1 30.2 46.4 28.45 44.8 27.05 46.75 26.0 48.2 25.35 50.8 24.55 53.75 25.45 54.75 28.15 57.85 30.9 61.75 34.15 66.4 34.5 68.15 34.85 69.9 34.2 69.8 33.6 69.65 33.3 68.7 33.05 67.85 29.65 62.8 26.0 57.45 24.0 55.2 22.65 53.65 23.8 49.85 24.8 46.35 26.6 44.5"
        />
        <path
          fill="#0d131a"
          d="M45.15 116.15 Q45.45 114.7 46.25 113.65 L46.85 113.6 Q47.1 114.05 46.85 114.6 L45.75 116.35 45.3 116.85 Q45.0 116.85 45.15 116.15"
        />
        <path
          fill="#0d131a"
          d="M53.1 85.7 Q54.8 81.3 59.65 78.1 61.55 76.9 61.7 77.35 61.85 77.75 60.65 78.65 63.5 79.75 65.65 83.15 67.5 86.25 67.65 88.85 67.8 91.35 64.4 94.35 60.35 97.95 54.0 98.95 L52.45 99.0 Q52.2 98.85 52.1 97.5 51.45 90.05 53.1 85.7 M60.0 79.15 Q51.85 84.85 53.0 98.3 58.45 97.85 62.9 94.05 66.55 90.95 66.6 89.05 66.65 87.1 64.75 83.85 62.55 80.2 60.0 79.15"
        />
        <path
          fill="#0d131a"
          d="M55.25 83.35 L55.5 82.75 Q58.85 84.15 60.15 87.35 61.1 89.65 61.1 92.1 61.1 94.55 60.2 96.4 L59.65 96.6 Q60.45 94.95 60.35 92.6 60.25 90.3 59.35 88.05 57.75 84.3 55.25 83.35"
        />
        <path
          fill="#0d131a"
          d="M144.35 20.75 Q145.85 21.6 146.15 24.2 146.45 26.85 144.85 27.15 L138.2 27.7 133.35 28.1 Q133.15 28.45 132.8 31.45 L132.2 36.6 Q128.05 65.45 121.7 70.8 115.65 75.9 105.75 79.1 96.15 82.15 86.0 82.5 83.95 82.6 83.75 81.95 83.55 81.3 85.7 81.35 89.9 81.45 99.45 79.05 113.0 75.65 120.0 69.6 124.2 66.0 127.7 51.35 129.7 43.0 130.8 34.55 L131.35 29.2 Q131.75 26.7 132.5 26.6 L143.5 25.6 Q144.35 25.5 144.15 23.95 144.0 22.45 143.25 21.95 122.95 14.75 116.9 14.75 112.9 14.75 102.5 20.5 93.45 25.5 91.25 27.65 89.85 28.95 89.4 28.9 88.95 28.85 89.45 27.65 90.6 24.85 95.65 18.4 L100.5 12.0 Q100.65 11.35 100.0 10.35 L99.05 9.3 Q97.65 9.6 94.5 11.45 90.25 13.9 86.75 17.2 82.85 20.9 76.95 31.2 72.0 39.7 70.2 44.3 68.6 48.35 67.9 64.05 67.75 67.85 67.15 67.65 66.55 67.5 66.5 66.05 66.35 60.8 66.6 55.5 67.0 47.3 68.25 44.15 70.85 37.6 75.75 29.5 81.5 20.0 86.6 15.15 89.65 12.25 94.45 9.75 98.5 7.65 99.65 7.65 100.3 7.65 101.3 9.25 102.35 11.0 102.05 12.15 L98.2 17.5 92.75 24.75 Q98.55 20.35 105.2 16.95 112.8 13.05 116.9 13.05 121.3 13.05 132.4 16.5 142.0 19.45 144.35 20.75"
        />
        <path
          fill="#0d131a"
          d="M82.15 41.5 Q84.35 37.6 92.5 32.25 99.75 27.45 103.85 26.25 106.25 25.5 111.55 25.3 117.25 25.05 117.85 26.05 123.85 43.4 120.9 52.8 119.0 59.0 115.6 63.85 112.8 67.85 110.1 69.6 105.9 72.35 96.85 74.65 90.6 76.25 84.75 77.1 83.85 77.25 83.85 76.65 L84.05 76.05 Q83.7 74.35 82.65 72.55 80.65 68.95 77.45 68.15 76.55 68.65 76.45 67.65 75.8 61.9 77.85 53.45 79.7 45.9 82.15 41.5 M93.85 33.05 Q85.7 38.4 83.8 41.7 81.8 45.3 79.55 53.2 77.25 61.5 77.25 65.85 77.25 66.65 77.4 67.25 81.55 67.9 83.45 71.45 84.5 73.3 85.0 76.05 103.7 72.6 109.55 68.8 112.0 67.2 114.5 63.45 117.5 58.95 119.35 52.9 120.2 50.05 120.2 46.2 120.2 37.4 116.55 26.7 L111.25 26.45 Q106.55 26.7 104.15 27.4 101.05 28.3 93.85 33.05"
        />
        <path
          fill="#0d131a"
          d="M81.55 44.45 Q85.35 41.3 93.85 39.35 103.75 37.05 106.45 41.1 109.1 45.05 109.1 54.05 109.1 62.3 107.45 65.2 105.6 68.4 103.2 70.85 L101.05 72.75 98.4 73.55 101.1 71.2 Q104.15 68.25 105.9 65.1 107.4 62.5 107.6 54.7 107.85 45.85 105.3 42.0 102.9 38.45 92.85 41.1 84.8 43.2 81.0 45.7 L81.55 44.45"
        />
        <path
          fill="#0d131a"
          d="M94.7 125.2 L96.85 137.55 Q99.0 149.9 100.15 153.6 99.45 153.7 98.55 154.45 97.15 149.55 95.7 141.1 94.2 132.15 93.6 124.4 93.5 122.95 94.0 123.55 94.45 124.05 94.7 125.2"
        />
        <path
          fill="#0d131a"
          d="M125.95 133.2 Q126.45 131.35 126.75 132.2 127.05 133.05 126.3 135.8 124.65 141.8 121.65 147.95 119.05 153.35 116.8 156.2 L115.9 155.25 Q118.0 152.4 121.9 143.4 125.3 135.55 125.95 133.2"
        />
        <path
          fill="#0d131a"
          d="M104.3 157.8 Q103.65 156.65 102.15 155.35 100.5 153.9 99.75 154.2 99.25 154.4 98.45 155.5 97.65 156.6 97.45 157.5 L97.4 157.9 97.45 158.05 101.3 158.4 Q103.85 158.25 104.3 157.8 M102.9 154.3 Q104.45 155.9 105.25 157.45 105.5 158.0 105.1 158.45 104.45 159.25 100.65 159.4 L96.0 159.05 Q95.35 158.75 96.4 156.6 97.55 154.2 99.65 152.9 100.8 152.15 102.9 154.3"
        />
        <path
          fill="#0d131a"
          d="M114.85 160.75 Q115.45 160.8 115.85 160.4 L116.6 158.95 116.75 157.55 Q116.6 156.5 115.45 155.35 114.2 154.05 112.8 153.85 111.6 153.65 109.3 154.75 107.0 155.85 106.05 157.0 105.65 157.55 105.75 157.8 106.0 158.45 108.6 159.3 L114.85 160.75 M112.85 152.55 Q114.6 152.8 116.15 154.55 117.55 156.1 117.7 157.4 118.15 159.9 117.2 161.25 116.45 162.15 115.15 162.0 L109.25 160.65 Q105.35 159.4 104.85 158.15 104.5 157.45 105.3 156.4 106.4 155.0 108.9 153.7 111.4 152.35 112.85 152.55"
        />
        <path
          fill="#0d131a"
          d="M85.8 89.5 Q100.35 83.8 107.9 82.7 L109.05 82.8 108.1 83.5 92.4 89.85 67.2 101.0 66.2 101.05 Q66.1 100.65 66.8 100.35 69.6 98.95 82.05 93.4 97.9 86.3 104.6 83.95 100.55 84.8 87.05 90.05 75.05 94.65 66.9 98.25 66.0 98.65 65.8 98.25 65.6 97.9 66.6 97.5 L85.8 89.5"
        />
        <path
          fill="#0d131a"
          d="M57.7 108.4 L76.0 109.35 95.8 110.95 Q96.85 111.2 96.75 111.45 L95.75 111.75 84.1 111.45 67.2 111.15 57.2 111.05 Q56.5 111.0 56.85 110.7 57.25 110.35 57.7 110.4 L67.65 110.5 84.95 110.9 90.6 111.0 84.95 110.6 57.8 109.2 Q57.2 109.2 57.0 108.85 56.75 108.45 57.7 108.4"
        />
      </g>
    </svg>
  );
};

export default NidoranF;
